const stickyATC = document.querySelector(".main-add-to-basket");
const normalATC = document.querySelector(".product__info-wrapper .buy-button-wrapper");

function toggleStickyATC() {
  const rect = ((normalATC.getBoundingClientRect()).bottom - 80);

  // Show sticky ATC only when normal ATC is above viewport
  if (rect < 0) {
    stickyATC.classList.remove("hidden");
    stickyATC.classList.add("visible");
  } else {
    stickyATC.classList.add("hidden");
    stickyATC.classList.remove("visible");
  }
}

toggleStickyATC();
window.addEventListener("scroll", toggleStickyATC);